import "./svg/nav-cart-quantity.svg"

export default {
    name: "nav-cart-quantity",
    viewBox: "25 25",
}
